/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ShareThreadContentBody = zod.object({
  permissions: zod
    .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
    .min(1)
    .describe(
      'Granted to every current share candidate. Core refuses any bit the caller does not hold.',
    ),
});

export type ShareThreadContentBody = zod.input<typeof ShareThreadContentBody>;
export type ShareThreadContentBodyOutput = zod.output<typeof ShareThreadContentBody>;
